import { BaseEdge, Position } from '@xyflow/react';
import { useMemo, CSSProperties } from 'react';

import { createOffsetPath } from './edge-offset';
import { EEdgeType } from './types';

interface CustomEdgePathProps {
  edgeState: { edgePath: string; labelX: number; labelY: number };
  edgeColors: string[];
  id: string;
  markerEnd?: string;
  style: CSSProperties;
  strokeWidth: number;
  edgeType?: EEdgeType;
  smoothStepParams?: {
    sourceX: number;
    sourceY: number;
    sourcePosition: Position;
    targetX: number;
    targetY: number;
    targetPosition: Position;
    borderRadius?: number;
  };
}

const GAP = 0;

export default function CustomEdgePath({
  edgeState,
  edgeColors,
  id,
  markerEnd,
  style,
  strokeWidth,
  edgeType,
  smoothStepParams,
}: CustomEdgePathProps) {
  const offsetPaths = useMemo(() => {
    const count = edgeColors.length;
    const gap = strokeWidth * GAP;

    return edgeColors.map((_, i) => {
      const offset = (i - (count - 1) / 2) * (strokeWidth + gap);
      return createOffsetPath(
        edgeState.edgePath,
        offset,
        edgeType,
        smoothStepParams,
      );
    });
  }, [edgeState.edgePath, edgeColors, strokeWidth, edgeType, smoothStepParams]);

  return (
    <>
      {edgeColors.map((color, i) => (
        <BaseEdge
          key={`${id}-${i}`}
          path={offsetPaths[i]}
          markerEnd={
            i === Math.floor(edgeColors.length / 2) ? markerEnd : undefined
          }
          style={{ ...style, stroke: color, strokeWidth }}
        />
      ))}
    </>
  );
}
